import { LegalLayout } from "@/components/LegalLayout";
import { Ph } from "@/lib/draft";

export default function CookiePolicyPage() {
    return (
        <LegalLayout title="Cookie policy">
            <p>
                <strong>Bozza predisposta per la pubblicazione:</strong> da completare con i dati del titolare.
            </p>
            <h2>Cosa usiamo</h2>
            <p>Questo sito non usa cookie di profilazione né tracciamento pubblicitario.</p>
            <h2>Archiviazione tecnica</h2>
            <ul>
                <li>
                    <strong>Preferenze di consenso</strong>: la scelta «Accetta/Rifiuta» viene salvata nel
                    localStorage del tuo browser (equivalente di cookie tecnico, non richiede consenso).
                </li>
            </ul>
            <h2>Servizi di terze parti soggetti a consenso</h2>
            <ul>
                <li>
                    <strong>Google Maps</strong>: la mappa nella sezione «Dove siamo» viene caricata solo dopo il
                    tuo consenso; puoi attivarla in ogni momento dal pulsante dedicato.
                </li>
                <li>
                    <strong>Google Fonts</strong>: tipografia servita dai server di Google.
                </li>
            </ul>
            <h2>Gestione delle preferenze</h2>
            <p>
                Puoi cambiare idea in qualsiasi momento dal link «Preferenze cookie» nel footer del sito, oppure
                cancellando i dati di navigazione del tuo browser.
            </p>
            <h2>Titolare</h2>
            <p>
                River Pub di Giuntini Andrea F. &amp; C. sas — Via Covona 160, 51039 Quarrata (PT) · P.IVA / Codice
                Fiscale 00362290470 · Contatto email ufficiale (PEC): riverpub@pec.it.
            </p>
        </LegalLayout>
    );
}